import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";

interface ContactListFiltersProps {
  typeFilter: 'all' | 'client' | 'prospect';
  onTypeFilterChange: (value: 'all' | 'client' | 'prospect') => void;
  searchFilter: string;
  onSearchFilterChange: (value: string) => void;
  contactType: 'email' | 'sms';
  totalContacts: number;
  filteredContacts: number;
  currentPage: number;
  totalPages: number;
}

export function ContactListFilters({
  typeFilter,
  onTypeFilterChange,
  searchFilter,
  onSearchFilterChange,
  contactType,
  totalContacts,
  filteredContacts,
  currentPage,
  totalPages,
}: ContactListFiltersProps) {
  const searchPlaceholder = contactType === 'email' 
    ? "Search by name or email..." 
    : "Search by name or phone...";

  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="flex items-center gap-2">
        <Label htmlFor="typeFilter" className="text-sm font-medium">Filter by Type:</Label>
        <Select value={typeFilter} onValueChange={onTypeFilterChange}>
          <SelectTrigger className="w-32">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="client">Clients</SelectItem>
            <SelectItem value="prospect">Prospects</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex items-center gap-2 flex-1">
        <Label htmlFor="searchFilter" className="text-sm font-medium">Search:</Label>
        <Input
          id="searchFilter"
          placeholder={searchPlaceholder}
          value={searchFilter}
          onChange={(e) => onSearchFilterChange(e.target.value)}
          className="max-w-xs"
        />
      </div>

      <div className="flex items-center gap-2">
        <Badge variant="outline" className="text-sm">
          {filteredContacts} of {totalContacts} contacts
        </Badge>
        {totalPages > 1 && (
          <Badge variant="secondary" className="text-sm">
            Page {currentPage} of {totalPages}
          </Badge>
        )}
      </div>
    </div>
  );
}

